import { IndicatorType } from '../constants/common'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class WilliamsR extends Indicator<Attrs> {
  static type = IndicatorType.Wr
  static label = 'Williams %R'

  declare period: number
  r: number[] = []

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (this.isComputeNecessary()) {
      this.r = []
      for (let i = this.period; i < this.data.close.length; i++) {
        let highestHigh = this.data.high[i]
        let lowestLow = this.data.low[i]
        for (let j = i - this.period + 1; j <= i; j++) {
          if (this.data.high[j] > highestHigh) {
            highestHigh = this.data.high[j]
          }
          if (this.data.low[j] < lowestLow) {
            lowestLow = this.data.low[j]
          }
        }

        this.r[i] = 0
        if (highestHigh - lowestLow > 0) {
          this.r[i] = ((highestHigh - this.data.close[i]) / (highestHigh - lowestLow)) * -100
        }
      }

      this.lastValue = this.r.last() ?? null
    }
    const { min, max } = this.r.length > 0 ? this.computeVisibleMinMax(this.r) : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  getValueLabelsAtIndex(index: number) {
    return this.getOversoldOverboughtValueLabelsAtIndex(index, this.r)
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    this.renderOversoldOverbought(context, this.r, this.period, -80, -50, -20)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 14,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `W%R ${this.period}`
  }
}

export default WilliamsR
